import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 页面组件 - 懒加载
const Home = () => import('@/views/Home.vue'); // 工作台
const PatientList = () => import('@/views/patient/List.vue'); // 患者列表
const ConsultationOrders = () => import('@/views/orders/Consultation.vue'); // 问诊单
const ConsultationDetail = () => import('@/views/orders/ConsultationDetail.vue'); // 问诊单详情
const PrescriptionOrders = () => import('@/views/orders/Prescription.vue'); // 处方单
const PrescriptionDetail = () => import('@/views/orders/PrescriptionDetail.vue'); // 问诊单详情

const DrugOrders = () => import('@/views/orders/Drug.vue'); // 药品订单
const DrugDetail = () => import('@/views/orders/DrugDetail.vue'); // 药品订单详情

const Schedule = () => import('@/views/user/Schedule.vue'); // 我的排班
const Reviews = () => import('@/views/user/Reviews.vue'); // 我的评价
const Templates = () => import('@/views/user/Templates.vue'); // 处方模板
const Notifications = () => import('@/views/settings/Notifications.vue'); // 消息通知
const Agreement = () => import('@/views/settings/Agreement.vue'); // 注册协议
const PrivacyPolicy = () => import('@/views/settings/Privacy.vue'); // 隐私协议
const ChangePassword = () => import('@/views/settings/ChangePassword.vue'); // 修改密码

const LoginViews = () => import('@/views/login/Login.vue'); // 登录页面
const ListConsultation = () => import('@/views/patient/ListConsultation'); // 患者问诊记录
const chat = () => import('@/views/patient/chat'); // 患者问诊记录
const messageList = () => import('@/views/user/messageList'); // 患者问诊记录
const myYizhu = () => import('@/views/user/myYizhu.vue'); // 我的医助
const medicakAdvice = () => import('@/views/user/medicakAdvice.vue'); // 我的医嘱

const NotificationsDetail = () => import('@/views/settings/NotificationsDetail.vue'); //

// 公共路由（无需权限即可访问）
export const constantRoutes = [
    {
        path: '/login',
        component: LoginViews,
        meta: { title: '登录', layout: 'login' },
        hidden: true, // 不在菜单中显示
    },

    {
        path: '/',
        component: Home,
        meta: { title: '工作台', requiresAuth: true },
    },
    {
        path: '/patient/list',
        component: PatientList,
        meta: { title: '患者列表', requiresAuth: true },
    },
    {
        path: '/patient/ListConsultation',
        component: ListConsultation,
        meta: { title: '患者问诊列表', requiresAuth: true },
    },
    {
        path: '/patient/chat',
        component: chat,
        meta: { title: '患者会话', requiresAuth: true },
    },

    {
        path: '/orders/consultation',
        component: ConsultationOrders,
        meta: { title: '问诊单', requiresAuth: true },
    },
    {
        path: '/orders/consultationDetail',
        component: ConsultationDetail,
        meta: { title: '问诊单详情', requiresAuth: true, isDetail: true },
    },
    {
        path: '/orders/prescription',
        component: PrescriptionOrders,
        meta: { title: '处方单', requiresAuth: true },
    },

    {
        path: '/orders/prescriptionDetail',
        component: PrescriptionDetail,
        meta: { title: '处方单详情', requiresAuth: true, isDetail: true },
    },

    {
        path: '/orders/drug',
        component: DrugOrders,
        meta: { title: '药品订单', requiresAuth: true },
    },
    {
        path: '/orders/drugDetail',
        component: DrugDetail,
        meta: { title: '药品订单详情', requiresAuth: true, isDetail: true },
    },

    {
        path: '/user/schedule',
        component: Schedule,
        meta: { title: '我的排班', requiresAuth: true },
    },

    {
        path: '/user/reviews',
        component: Reviews,
        meta: { title: '我的评价', requiresAuth: true },
    },

    {
        path: '/user/templates',
        component: Templates,
        meta: { title: '处方模版', requiresAuth: true },
    },

    {
        path: '/settings/notifications',
        component: Notifications,
        meta: { title: '消息通知', requiresAuth: true },
    },
    {
        path: '/settings/NotificationsDetail',
        component: NotificationsDetail,
        meta: { title: '通知详情', requiresAuth: true },
    },

    {
        path: '/agreement',
        component: Agreement,
        meta: { title: '注册协议', layout: 'agreement' },
        hidden: true, // 不在菜单中显示
    },
    {
        path: '/privacy',
        component: PrivacyPolicy,
        meta: { title: '隐私协议', layout: 'privacy' },
        hidden: true, // 不在菜单中显示
    },
    {
        path: '/settings/change-password',
        component: ChangePassword,
        meta: { title: '修改密码', requiresAuth: true },
    },
    {
        path: '/user/messageList',
        component: messageList,
        meta: { title: '会话列表', requiresAuth: true },
    },

    {
        path: '/user/myYizhu',
        component: myYizhu,
        meta: { title: '我的医助', requiresAuth: true },
    },
    {
        path: '/user/medicakAdvice',
        component: medicakAdvice,
        meta: { title: '我的医嘱', requiresAuth: true },
    },
];

// 创建路由器
const router = new VueRouter({
    mode: 'hash',
    routes: constantRoutes,
});

// 路由守卫
// const whiteList = ["/login"]; // 白名单，无需登录即可访问的路径
router.beforeEach((to, from, next) => {
    next(); // 正常跳转
    // return;
    // const token = localStorage.getItem("admin_token");
    // if (token) {
    //     // 如果已登录
    //     if (to.path === "/login") {
    //         next({ path: "/" }); // 跳转到工作台
    //     } else {
    //         next(); // 正常跳转
    //     }
    // } else {
    //     // 如果未登录
    //     if (whiteList.includes(to.path)) {
    //         next(); // 放行白名单中的页面
    //     } else {
    //         next("/login"); // 重定向到登录页
    //     }
    // }
});

export default router;
